<template>
	<div class="cn_con">
		<div class="cont_page_pc" v-if="!isPhone">
			<div class="cont_con" data-aos="fade-up">
				<p class="con_tit">欢迎来到剑南春！</p>
				<p class="con_tit2">
					我们致力于为您提供更优质的产品和更好的服务，如果您有任何需要，可以通过以下方式联系我们，我们会尽快给您回复！
				</p>
				<div class="con_type flex1">
					<div class="type_item tt_d1">
						<p class="tt_p1">联系方式</p>
						<p>客户服务热线：{{bsinfo.phone1}}</p>
						<p>总机电话：{{bsinfo.phone2}}</p>
						<p>产品真伪咨询电话：{{bsinfo.phone3}}</p>
						<p>假冒产品举报电话：{{bsinfo.phone4}}</p>
						<p>产品质量咨询：{{bsinfo.phone5}}</p>
						<p>广告合作：{{bsinfo.gemail}}</p>
					</div>
					<div class="type_item tt_d2">
						<div class="d2_box d2_sty1">
							<p class="db_p1">公司地址</p>
							<p class="db_p2">{{bsinfo.address}}</p>
						</div>
						<div class="d2_box d2_sty2" style="padding: 10px 10px 30px 20px;">
							<p class="db_p1">在线客服</p>
							<p class="db_p2" style="font-size: 16px;">
								人工客服在线时间：
							</p>
							<p class="db_p2" style="font-size: 16px;">
								在线时间：{{bsinfo.kfshijian}}
							</p>
							<p class="db_p3 flex2" style="margin-top: 10px;" @click="toChat">
								<img src="@/images/contact/kf.png" />
								<span>在线咨询</span>
							</p>
						</div>
					</div>
					<div class="type_item tt_d3">
						<div class="d3_box1 flex1">
							<div class="d3_item" @click="toWeiBo">
								<img src="@/images/contact/wb.png" />
								<span>官方微博：剑南春</span>
							</div>
							<div class="d3_item" @click="visible = true">
								<img src="@/images/contact/dy.png" />
								<span>官方抖音：剑南春</span>
							</div>
							<div class="d3_item" @click="visible2 = true">
								<img src="@/images/contact/xhs.png" />
								<span>官方小红书：剑南春</span>
							</div>
						</div>
						<div class="d3_box2 flex1">
							<div class="d3_item">
								<img :src="ma4[0]" />
								<span>剑南春微信订阅号</span>
							</div>
							<div class="d3_item">
								<img :src="ma4[1]" />
								<span>剑南春微信服务号</span>
							</div>
							<div class="d3_item">
								<img :src="ma4[3]" />
								<span>剑南春微信视频号</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog :visible.sync="visible" :show-close="false" width="30%" center>
				<div class="pop_box">
					<img class="pbimg_1" :src="staticImg+bsinfo.image" />
					<p>扫码可以关注剑南春抖音官方号</p>
				</div>
			</el-dialog>
			<el-dialog :visible.sync="visible2" :show-close="false" width="30%" center>
				<div class="pop_box">
					<img class="pbimg_2" :src="ma4[2]" />
					<p>扫码可以关注剑南春小红书官方号</p>
				</div>
			</el-dialog>
		</div>
		<div class="cont_page_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="联系我们"></Header2>
			<p class="cpp_tit" data-aos="fade-up">欢迎来到剑南春</p>
			<p class="cpp_text" data-aos="fade-up">
				我们致力于为您提供更优质的产品和更好的服务，如果您有任何需要，可以通过以下方式联系我们，我们会尽快给您回复！
			</p>
			<div class="cpp_box" data-aos="fade-up">
				<ul class="cpp_box_ul">
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">客户服务热线 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.phone1}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">总机电话 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.phone2}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">产品真伪咨询电话 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.phone3}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">假冒产品举报电话 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.phone4}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">产品质量咨询 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.phone5}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">广告合作 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.gemail}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">公司地址 </span>
						<span class="cpp_box_li_sp2">{{bsinfo.address}}</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">官方微博 </span>
						<span class="cpp_box_li_sp2 flex3">
							<img src="@/images/contact/wb.png" />
							剑南春
						</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">官方抖音 </span>
						<span class="cpp_box_li_sp2 flex3" @click="handlePop(1)">
							<img src="@/images/contact/dy.png" />
							剑南春
						</span>
					</li>
					<li class="cpp_box_li">
						<span class="cpp_box_li_sp1">官方小红书 </span>
						<span class="cpp_box_li_sp2 flex3" @click="handlePop(2)">
							<img src="@/images/contact/xhs.png" />
							剑南春
						</span>
					</li>
				</ul>
				<div class="code2_box">
					<p class="code2_tit"></p>
					<div class="code2_con">
						<div class="code2_item">
							<img :src="ma4[0]" />
							<p>微信订阅号</p>
						</div>
						<div class="code2_item">
							<img :src="ma4[1]" />
							<p>微信服务号</p>
						</div>
						<div class="code2_item">
							<img :src="ma4[3]" />
							<p>微信视频号</p>
						</div>
					</div>
				</div>
			</div>
			<div class="zxkf2" data-aos="fade-up">
				<div class="zxkf2_d1">
					<p class="zxkf2_d1_left">在线客服</p>
					<div class="zxkf2_d1_right flex2" @click="toChat2">
						<img src="@/images/contact/kf.png" />
						<span>在线客服</span>
					</div>
				</div>
				<div class="zxkf2_d2">
					人工客服在线时间：{{bsinfo.kfshijian}}
				</div>
			</div>
			<div class="amd_wrap" v-show="tkimg!=''" @click="tkimg=''">
				<div class="amd_box">
					<div class="amd_con" @click.stop="stopMaoPao">
						<img v-if="tkimg==1" :src="staticImg+bsinfo.image">
						<img v-if="tkimg==2" :src="ma4[2]">
						<p>扫码可以关注剑南春{{tkimg==1?'抖音':'小红书'}}官方号</p>
					</div>
				</div>
			</div>
		</div>
		<transition name="fade">
			<div v-show="chatbox&&!isPhone" class="fram_wrap animate__animated" :class="ulani">
				<iframe class="fram_box" :src="bsinfo.kefurl" frameborder="0"></iframe>
			</div>
		</transition>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			visible2: false,
			chatbox: false,
			isPhone: this.$isMobile,
			ulani: "",
			staticImg: this.$staticImg,
			bsinfo: {},
			ma4: [],//0订阅号、1服务号、2小红书、3视频号
			tkimg: '',
		}
	},
	created() {
		this.basicInfo();
	},
	methods: {
		// 基础信息
		async basicInfo() {
			const res = await this.$api.basicInfo();
			if (res.code == 1) {
				this.bsinfo = res.data;
				this.ma4 = this.bsinfo.images.split(',');//0订阅号、1服务号、2小红书、3视频号
				for (let i = 0; i < this.ma4.length; i++) {
					this.ma4[i] = this.$staticImg + this.ma4[i]
				}
			}
		},
		toWeiBo() {
			window.open("https://weibo.com/p/1006063921129720/home", "_blank");
		},
		toChat() {
			this.chatbox = !this.chatbox;
			if (this.chatbox) {
				this.ulani = "animate__slideInUp";
			} else {
				this.ulani = "animate__slideOutDown";
			}
		},
		toChat2() {
			window.open("https://jnchun.udesk.cn/im_client/");
		},
		handlePop(a) {
			this.tkimg = a;
		},
		stopMaoPao() {

		}
	}
}
</script>

<style lang="scss">
.fram_wrap {
	position: fixed;
	bottom: 0;
	right: 60px;
	width: 364px;
	height: 572px;
	background-color: #fff;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
	border-radius: 4px;
	z-index: 1000000005;
	animation-duration: 0.4s !important;
	.fram_box {
		width: 364px;
		height: 572px;
	}
}

.cn_con {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.cont_page_pc {
		margin-top: 76px;
		background-image: url("../../images/contact/bgimg.png");
		background-repeat: no-repeat;
		background-size: cover;
		background-position: 50%;
		padding: 120px 20px 0;
		.pop_box {
			.pbimg_1 {
				display: block;
				margin: 0 auto;
			}
			.pbimg_2 {
				display: block;
				margin: 0 auto;
				width: 200px;
			}
			p {
				text-align: center;
				font-size: 20px;
			}
		}
		.cont_con {
			max-width: 1350px;
			min-width: 1000px;
			margin: 0 auto;
			padding-bottom: 150px;
			.con_tit {
				text-align: center;
				color: #c0494b;
				font-size: 36px;
				margin-bottom: 26px;
			}
			.con_tit2 {
				text-align: center;
				color: #666;
				font-size: 18px;
				line-height: 1.8;
				margin-bottom: 78px;
			}
		}
		.con_type {
			.type_item {
				margin-left: 10px;
				&:nth-child(1) {
					width: 30%;
					margin-left: 0;
				}
				&:nth-child(2) {
					width: 30%;
				}
				&:nth-child(3) {
					width: 40%;
				}
			}
			.tt_d1 {
				height: 393px;
				background-color: hsla(0, 0%, 100%, 0.6);
				padding: 30px 10px 30px 20px;
				color: #888;
				font-size: 18px;
				line-height: 2;
				box-sizing: border-box;
				.tt_p1 {
					font-size: 24px;
					color: #333;
					margin-bottom: 18px;
				}
				p {
					margin-bottom: 13px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					text-align: left;
				}
			}
			.tt_d2 {
				.d2_sty1 {
					height: 154px;
					margin-bottom: 11px;
				}
				.d2_sty2 {
					height: 228px;
				}
				.d2_box {
					background-color: hsla(0, 0%, 100%, 0.6);
					padding: 30px 10px 30px 20px;
					color: #888;
					font-size: 18px;
					line-height: 2;
					box-sizing: border-box;
					p {
						text-align: left;
					}
					.db_p1 {
						font-size: 24px;
						color: #333;
						margin-bottom: 10px;
					}
					.db_p2 {
						margin-top: 10px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}
					.db_p3 {
						width: 190px;
						height: 54px;
						line-height: 54px;
						text-align: center;
						color: #328fee;
						font-size: 20px;
						border-radius: 54px;
						box-shadow: 0 4px 6px 0 hsla(0, 0%, 72%, 0.6);
						margin-top: 24px;
						cursor: pointer;
						span {
							margin-left: 5px;
						}
					}
				}
			}
			.tt_d3 {
				.d3_box1,
				.d3_box2 {
					background-color: hsla(0, 0%, 100%, 0.6);
					padding: 22px 28px;
					box-sizing: border-box;
					.d3_item {
						width: 33.3%;
						span {
							display: block;
							font-size: 16px;
							padding-top: 14px;
							color: #333;
						}
					}
				}
				.d3_box1 {
					margin-bottom: 11px;
					height: 154px;
					.d3_item {
						cursor: pointer;
						img {
							width: 60px;
							height: 60px;
						}
						span {
							font-size: 15px;
						}
					}
				}
				.d3_box2 {
					height: 228px;
					img {
						width: 120px;
						height: 120px;
					}
					span {
						font-size: 15px;
					}
				}
			}
		}
	}
	.cont_page_phone {
		background-image: url("../../images/bgimg3.png");
		padding: 0.45rem 0.53rem;
		min-height: 90vh;
		.amd_wrap {
			position: fixed;
			left: 0;
			bottom: 0;
			left: 0;
			right: 0;
			z-index: 99;
			background-color: rgba(0, 0, 0, 0.5);
			.amd_box {
				width: 100vw;
				height: 100vh;
				display: flex;
				justify-content: center;
				align-items: center;
				align-content: center;
				.amd_con {
					background-color: #fff;
					border-radius: 7px;
					padding: 15px 25px;
					img {
						width: 200px;
						margin: 0 auto;
					}
					p {
						font-size: 15px;
						color: #888;
						line-height: 1.5;
					}
				}
			}
		}
		.pop_box {
			.pbimg_1 {
				display: block;
				margin: 0 auto;
			}
			.pbimg_2 {
				display: block;
				margin: 0 auto;
				width: 150px;
			}
			p {
				text-align: center;
				font-size: 15px;
			}
		}
		.cpp_tit {
			color: #c0494b;
			font-weight: 700;
			text-align: center;
			font-size: 19px;
			margin-bottom: 0.32rem;
			margin-top: 1.23rem;
		}
		.cpp_text {
			color: #666;
			font-size: 14px;
			line-height: 1.8;
			margin-bottom: 0.59rem;
			text-align: left;
		}
		.cpp_box {
			background-color: hsla(0, 0%, 100%, 0.6);
			padding: 0.27rem 0.45rem 0.61rem;
			.cpp_box_ul {
				.cpp_box_li {
					padding: 0.27rem 0;
					border-bottom: 1px solid #dfdfdf;
					text-align: left;
					display: flex;
					align-items: center;
					.cpp_box_li_sp1 {
						width: 124px;
						color: #666;
						display: inline-block;
						line-height: 0.8rem;
						font-size: 14px;
						vertical-align: middle;
					}
					.cpp_box_li_sp2 {
						line-height: 0.8rem;
						font-size: 14px;
						vertical-align: middle;
						img {
							width: 1.1rem;
							height: 1.1rem;
							border-radius: 50%;
							margin-right: 0.29rem;
						}
					}
				}
			}
		}
		.code2_box {
			margin-top: 0.47rem;
			.code2_tit {
				margin-bottom: 0.53rem;
				font-size: 17px;
				color: #333;
			}
			.code2_con {
				display: flex;
				justify-content: space-between;
				.code2_item {
					img {
						width: 2.5rem;
						height: 2.5rem;
					}
					p {
						text-align: center;
						margin-top: 0.2rem;
						font-size: 14px;
						color: #333;
					}
				}
			}
		}
		.zxkf2 {
			background-color: hsla(0, 0%, 100%, 0.6);
			padding: 0.4rem 0.53rem;
			margin-top: 0.27rem;
			margin-bottom: 2.5rem;
			.zxkf2_d1 {
				display: flex;
				align-items: center;
				justify-content: space-between;
				color: #333;
				font-size: 17px;
				.zxkf2_d1_left {
				}
				.zxkf2_d1_right {
					width: 2.67rem;
					height: 0.8rem;
					box-shadow: 0 4px 6px 0 hsla(0, 0%, 72%, 0.6);
					border-radius: 0.8rem;
					line-height: 0.8rem;
					text-align: center;
					background-color: #fff;
					color: #328fee;
					font-size: 13px;
					img {
						width: 0.45rem;
					}
					span {
						margin-left: 0.1rem;
					}
				}
			}
			.zxkf2_d2 {
				color: #666;
				font-size: 12px;
				margin-top: 0.32rem;
				text-align: left;
			}
		}
	}
}
</style>